import { render, staticRenderFns } from "./PrivacyAndSecurity.vue?vue&type=template&id=2398eba6&scoped=true&"
import script from "./PrivacyAndSecurity.vue?vue&type=script&lang=ts&"
export * from "./PrivacyAndSecurity.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyAndSecurity.vue?vue&type=style&index=0&id=2398eba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2398eba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VDivider,VForm})
